import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
            <img src={logo} alt="Tylented" style={{ width: 28, height: 28, objectFit: 'contain' }} />
            <span style={{ fontFamily: 'var(--font)', fontSize: '1.05rem', fontWeight: 800, letterSpacing: '-.04em' }}>
              <span style={{ background: 'var(--grd-title)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Tylent</span>
              <span style={{ background: 'var(--grd-cyan)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>ed</span>
            </span>
          </Link>
          <p>Backend, AI automation & cloud engineering. Production-ready systems built to scale from day one.</p>
        </div>

        {/* <div className="footer-col">
          <h4>Tools</h4>
          <ul>
            {['Backend Development','AI & LLM Integration','Document Processing','Cloud & DevOps','Workflow Automation'].map(s => (
              <li key={s}><Link to="/services">{s}</Link></li>
            ))}
          </ul>
        </div> */}

        <div className="footer-col">
          <h4>Dev Tools</h4>
          <ul>
            <li><Link to="/tools/ip">Network Tools</Link></li>
            <li><Link to="/tools/dev">Dev Tools</Link></li>
            <li><Link to="/tools/files">File Tools</Link></li>

          </ul>
        </div>

        <div className="footer-col">
          <h4>Basic Tools</h4>
          <ul>
            <li><Link to="/tools/finance">Finance Tools</Link></li>
            <li><Link to="/tools/text">Text Tools</Link></li>
            <li><Link to="/tools/business">Business Tools</Link></li>

          </ul>
        </div>
{/* 
        <div className="footer-col">
          <h4>Contact</h4>
          <ul>
            <li><Link to="/contact">Book a Call</Link></li>
            <li><a href="mailto:contact@arhatinfo.com">contact@arhatinfo.com</a></li>
            <li><a href="https://upwork.com" target="_blank" rel="noreferrer">Upwork</a></li>
            <li><a href="https://fiverr.com" target="_blank" rel="noreferrer">Fiverr</a></li>
            <li><a href="https://github.com" target="_blank" rel="noreferrer">GitHub</a></li>
          </ul>
        </div> */}
      </div>

      <div className="footer-bottom">
        <Link to="/terms">Terms</Link>
<Link to="/privacy">Privacy</Link>
        <p>© 2026 Tylented  Backend, AI & Cloud Engineering</p>
        <p>Built with precision. Shipped with confidence.</p>
      </div>
    </footer>
  );
}
